var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "big" }, [
    _c(
      "div",
      { staticClass: "shadow" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 20 } },
          _vm._l(_vm.bianlidianCards, function(card, key) {
            return _c(
              "el-col",
              {
                key: key,
                attrs: { span: 4, xs: 8 },
                nativeOn: {
                  click: function($event) {
                    return _vm.toTarget(card.name)
                  }
                }
              },
              [
                _c(
                  "el-card",
                  { staticClass: "grid-content", attrs: { shadow: "hover" } },
                  [
                    _c("i", { class: card.icon, style: { color: card.color } }),
                    _c("p", [_vm._v("便利店")]),
                    _c("p", [_vm._v(_vm._s(card.label))])
                  ]
                )
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }